import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { labels } from '../../../../../constants/text';

export default class CostPayRates extends Component {
  static propTypes = {
    jobCostRate: PropTypes.oneOfType([
      PropTypes.string, // in case when field is empty it will be equal to empty string
      PropTypes.number
    ]),
    workerPayRate: PropTypes.oneOfType([
      PropTypes.string, // in case when field is empty it will be equal to empty string
      PropTypes.number
    ]),
    handleChangeCostPayRate: PropTypes.func.isRequired
  };

  render () {
    const { jobCostRate, workerPayRate, handleChangeCostPayRate } = this.props;
    return (
      <section className='job-posting-section half-width'>
        <header><h4>Rates</h4></header>
        <div className='d-flex'>
          <div className='mr-4'>
            <label className='label' htmlFor='pay-rate-input'>{ labels.pay_rate } ($/hr)</label>
            <input
              id='pay-rate-input'
              className='input cost-pay-rate-input'
              type='number'
              min='0'
              placeholder='0'
              name='workerPayRate'
              value={workerPayRate}
              onChange={handleChangeCostPayRate}
            />
          </div>
          <div>
            <label className='label' htmlFor='pay-rate-input'>{ labels.cost_rate } ($/hr)</label>
            <input
              id='cost-rate-input'
              className='input cost-pay-rate-input'
              type='number'
              min='0'
              placeholder='0'
              name='jobCostRate'
              value={jobCostRate}
              onChange={handleChangeCostPayRate}
            />
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/LocationScheduleStep/CostPayRates.js